var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnActiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 12,
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5001 26.7799L19.7201 23.9999L18.7734 24.9399L22.5001 28.6666L30.5001 20.6666L29.5601 19.7266L22.5001 26.7799Z",
    fill: "#21005D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnActiveIcon);
export default __webpack_public_path__ + "static/media/onActiveIcon.8afb620857a22ae1667984bb13238647.svg";
export { ForwardRef as ReactComponent };